import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/feature/Navbar";
import Footer from "../components/feature/Footer";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found | Superbuy Spreadsheet Forum";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      const el = document.head.querySelector('meta[name="robots"][content="noindex, nofollow"]');
      if (el) document.head.removeChild(el);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-32 pb-20 flex flex-col items-center justify-center text-center px-4">
        <span className="text-8xl md:text-9xl font-heading font-bold text-accent-600">404</span>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-4 mb-3">
          Page Not Found
        </h1>
        <p className="text-sm text-foreground-500 max-w-md mb-8">
          The page you are looking for might have been moved or does not exist. Return to the homepage to explore our superbuy spreadsheet guides.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-4-line text-xs"></i>
          </span>
          Back to Home
        </Link>
      </main>
      <Footer />
    </div>
  );
}